'use client';

import styles from './DevTools.module.css';
import DevNavigationPanel from './DevNavigationPanel';
import CloseButton from 'components/eligibility-modal/CloseButton';
import DevUserReset from './DevUserReset';
import DevUserProfile from './DevUserProfile';
import DevLogTesting from './DevLogTesting';
import DevRecommendationTrigger from './DevRecommendationTrigger';

type DevToolsPanelProps = {
  setIsOpen: (isOpen: boolean) => void;
};

const DevToolsPanel = ({ setIsOpen }: DevToolsPanelProps) => {
  const closePanel = () => {
    setIsOpen(false);
  };

  return (
    <div className={styles.devToolsPanel}>
      <CloseButton onClose={closePanel} />

      <DevUserProfile />
      <DevUserReset />
      <DevRecommendationTrigger />
      <DevNavigationPanel />
      <DevLogTesting />
    </div>
  );
};

export default DevToolsPanel;
